import React, { useEffect, useRef } from "react";

const TRAJECTORY_COUNT = 8;
const TRAJECTORY_CLASSES = Array.from(
  { length: TRAJECTORY_COUNT },
  (_, i) => `member-profile-card-popover__shooting-star--t${i + 1}`
);

function delayForQuantity(quantity) {
  const q = Math.max(0, Math.min(100, Number(quantity) || 50));
  const minDelay = 11000 - q * 95;
  const span = 5500 - q * 25;
  return Math.max(1200, minDelay + Math.floor(Math.random() * Math.max(500, span)));
}

/**
 * Shooting star on TL→BR presets (CSP-safe).
 * @param {{ quantity?: number }} props quantity 0–100 (frequency)
 */
export default function DonorShootingStar({ quantity = 50 }) {
  const starRef = useRef(null);
  const quantityRef = useRef(quantity);

  useEffect(() => {
    quantityRef.current = quantity;
  }, [quantity]);

  useEffect(() => {
    const el = starRef.current;
    if (!el) return undefined;

    const reduceMotion =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion) return undefined;

    let timeoutId = null;
    let cancelled = false;

    const fire = () => {
      if (cancelled || !starRef.current) return;
      const node = starRef.current;
      const next = TRAJECTORY_CLASSES[Math.floor(Math.random() * TRAJECTORY_COUNT)];
      node.classList.remove("is-flying", ...TRAJECTORY_CLASSES);
      void node.offsetWidth;
      node.classList.add(next, "is-flying");
    };

    const scheduleNext = () => {
      timeoutId = window.setTimeout(() => {
        fire();
        scheduleNext();
      }, delayForQuantity(quantityRef.current));
    };

    fire();
    scheduleNext();

    return () => {
      cancelled = true;
      if (timeoutId != null) window.clearTimeout(timeoutId);
    };
  }, []);

  return (
    <span
      ref={starRef}
      className="member-profile-card-popover__shooting-star"
      aria-hidden
    />
  );
}
